module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"mailNotificationDeactivate":"E-Mail-Benachrichtigung bei neuen Inhalten deaktivieren","mailNotificationActivate":"E-Mail-Benachrichtigung bei neuen Inhalten aktivieren"},"en":{"mailNotificationDeactivate":"Deactivate mail notification on content updates","mailNotificationActivate":"Activate mail notification on content updates"}}')
  delete Component.options._Ctor
}
